import {
    jornada,
    JornadaDiariaQueryXor,
    JornadaMensalQueryXor,
} from 'service/api'
import { useDigitacaoColumns } from '../columns'
import { DigitacaoDataGrid } from './DigitacaoDataGrid'
import { useDigitacaoContext } from './useDigitacaoContext'

export default function DigitacaoTodosPage() {
    const { queryParams } = useDigitacaoContext()
    const columns = useDigitacaoColumns()

    const {
        data: mensal,
        isFetching: isLoadingMensal,
        error: mensalError,
        isError: isErrorMensal,
    } = jornada.mensal.useFetch({
        queryParams: queryParams as JornadaMensalQueryXor,
        enabled: !('dia' in queryParams) && !!queryParams.funcionarioId,
    })

    const {
        data: diario,
        isFetching: isLoadingDiario,
        error: diarioError,
        isError: isErrorDiario,
    } = jornada.diaria.useFetch({
        queryParams: queryParams as JornadaDiariaQueryXor,
        enabled: 'dia' in queryParams && !!queryParams.empresaId,
    })

    return (
        <DigitacaoDataGrid
            columns={columns}
            dataDiario={diario}
            dataMensal={mensal}
            diarioError={diarioError}
            mensalError={mensalError}
            isErrorDiario={isErrorDiario}
            isErrorMensal={isErrorMensal}
            isLoadingDiario={isLoadingDiario}
            isLoadingMensal={isLoadingMensal}
        />
    )
}
